'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".ClickableChip-module_styledChipContainer__ERTW2{border:1px solid #1399d6;border-radius:20px;color:#2c2f33;display:inline-block;font-family:Helvetica Neue;font-size:.875rem;margin:.25rem .25rem .25rem 0;min-width:2rem;padding:.5rem 1rem;text-align:center}.ClickableChip-module_styledChipContainer__ERTW2:hover{cursor:pointer}";
var styles = {"styledChipContainer":"ClickableChip-module_styledChipContainer__ERTW2"};
styleInject["default"](css_248z, 'a8ce62dd-7c5c-4d05-98b1-c8fdc7ca455a');

exports["default"] = styles;
